import * as ToastPrimitive from "@radix-ui/react-toast";
import { ReactNode } from "react";
import styles from "./Toast.module.scss";
import ToastList from "./ToastList";

type Props = {
	children: ReactNode;
};

/**
 * トーストプロバイダー コンポーネント
 * @param props props
 * @returns トーストプロバイダーコンポーネント
 */
export function ToastProvider(props: Props) {
	const { children } = props;

	return (
		<ToastPrimitive.Provider duration={4000}>
			{children}
			<ToastList />
			<ToastPrimitive.Viewport className={styles.ToastViewport} />
		</ToastPrimitive.Provider>
	);
}
